<template>
  <li class="nav-item">
    <button
      class="nav-link px-1"
      :class="{
        active,
        disabled: disabled || !available || active,
      }"
      @click.prevent="handleClick"
      role="button"
    >
      <slot />
    </button>
  </li>
</template>

<script setup lang="ts">
const props = defineProps<{
  active?: boolean;
  available?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  if (!props.disabled && props.available && !props.active) {
    emit("click");
  }
};
</script>

<style scoped lang="scss">
.nav-link {
  border-radius: 30px;
}

.nav-link.active {
  background-color: var(--phoenix-gray-200);
  color: var(--phoenix-text-color);
  font-weight: bold;
}

.nav-link:not(.active):hover:not(.disabled) {
  background-color: var(--phoenix-gray-200);
  color: var(--phoenix-nav-link-color);
  font-weight: bold;
  transition-duration: 200ms;
  transition-property: background-color, font-weight;
  transition-timing-function: ease-out;
}

.nav-link:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
